import React from "react";
import useTitanApp from "../../../hooks/useTitanApp";
import { FaArrowRight } from "react-icons/fa6";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { setPatientInfoTab } from "../../../dispatchers/appDispatchers";
import {
  addPatientConsultation,
  getServiceAppointments,
  setConsultationId,
  setFreeTypeMode,
  setIsFinalSummary,
  setPatientAIChatMessages,
  setPatientNotes,
  setSignatureDetails,
  setTranscript,
} from "../../../dispatchers/patientDispatchers";
import { v4 as uuidv4 } from "uuid";
import { ConsultationStatus } from "../../../enum/ConsultationStatus";
import { setHydratedTemplateSections } from "../../../dispatchers/templateDispatchers";
import { ConsultationButtonStatus } from "../../../enum/ConsultationButtonStatus";
import { logEvent } from "../../../utils/GAUtils";
import { setShowNHS111ReferralTab } from "@/dispatchers/pharmacyServiceDispatchers";
export default function Actions() {
  const navigate = useNavigate();
  const { patientState, appState } = useTitanApp();
  const { currentPharmacy, currentPharmacyId, companyId, currentUser } =
    appState || {};
  const {
    selectedPatientDetails,
    selectedTemplate,
    hydratedTemplateSections,
    patientTranscription,
    addPatientConsultationLoader,
    consultationId,
  } = patientState || {};

  const handleStartConsultationClick = async () => {
    try {
      logEvent("button_click", {
        event_category: "User Interaction",
        event_label: "Patient Consultation Start",
        pharmacy_name: currentPharmacy.teamPharmacyName,
      });
    } catch (error) {}
    setFreeTypeMode(false);
    setTranscript("");
    setPatientNotes("");
    setHydratedTemplateSections(null);
    setSignatureDetails(null);
    setPatientAIChatMessages([]);
    const newConsultationId = uuidv4();
    setConsultationId(newConsultationId);

    try {
      const consultationData = {
        consultationId: newConsultationId,
        patientId: selectedPatientDetails?.patientID,
        patientName:
          (selectedPatientDetails?.foreName || "") +
          " " +
          (selectedPatientDetails?.surName || ""),
        pharmacyID: currentPharmacyId,
        serviceID: "6880e77b98b936f8365ab340",
        serviceName: "General Service",
        consultationSummary: "",
        transcription: "",
        actions: [],
        companyID: companyId,
        consultationStatus: 2,
        createdByName: currentUser?.fullName || "",
        consultationButtonStatus: ConsultationButtonStatus.InProgress,
      };
      await addPatientConsultation(consultationData);
    } catch (error) {
      console.error("Failed to save consultation:");
    }
    setPatientInfoTab(1);
    setShowNHS111ReferralTab(false);
    navigate(
      `/pharmacy/patientconsultation/${currentPharmacy.teamPharmacyID}/${selectedPatientDetails?.patientID}/${newConsultationId}`,
    );
  };
  const actions = [];
  if (selectedPatientDetails) {
    actions.push({
      label: "Start Consultation",
      value: "Start a new consultation for this patient ",
      isDiabled: addPatientConsultationLoader,
      action: handleStartConsultationClick,
    });
  }
  return (
    <React.Fragment>
      <div className="tasks_header">
        <h3 className="pharmacy_header_name">Actions</h3>
        {/* {darkMode ? <AddNewLightSvg /> : <AddNewDarkSvg />} */}
      </div>
      <div className="patient-actions-wrapper">
        {actions?.map((action, index) => (
          <div
            key={index}
            className={`patient-action-box ${
              action.isDiabled ? "disabled" : ""
            }`}
            onClick={action.isDiabled ? undefined : action.action}
          >
            <div className="patient-action-wrapper">
              <div className="patient-action-header-wrapper">
                <div className="patient-action-header">
                  <IoIosAddCircleOutline size={20} className="icons-color" />
                  <p className="patient-action-label">{action.label}</p>
                </div>
                <FaArrowRight
                  size={20}
                  className="patient-dashboard-icons-color action-icon"
                />
              </div>
              <p className="patient-action-value">{action.value}</p>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}
